import { render, staticRenderFns } from "./repayRecord.vue?vue&type=template&id=504c1ff8"
import script from "./repayRecord.vue?vue&type=script&lang=js"
export * from "./repayRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports